import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import BackButton from './BackButton';


class SubscriptionCancel extends Component {

  state = {
    isLoading: false,
    errorMessage: '',
    subscriptionCancelSuccess: false,
    subscription: this.props.subscriptionStatus
  };

  cancelSubscription = async (subscription) => {
    const response = await this.props.subscriptionApi.cancelSubscription(subscription)
    if (!response.ok) {
      this.setState({
          errorMessage: `Failed to create subscription: ${response.status} ${response.statusText}`,
          isLoading: false
        }
      )
    } else {
      const jsonData = await response.json();
      this.setState({
        subscriptionCancelSuccess: true,
        subscription: jsonData,
        isLoading: false
      });
      await this.props.resetSubscription();
    }
  };

  render() {
    const {errorMessage, subscription, subscriptionCancelSuccess} = this.state;

    return (
      <div className="app">
        {this.props.navbar}
        <div className="page-container">
          <BackButton/>
          <span className="page-eyebrow">Subscription</span>
          <h2 className="page-title">Cancel subscription</h2>

          {errorMessage &&
            <div className="alert callout callout-warning">{errorMessage}</div>
          }

          {!subscriptionCancelSuccess ? (
            <div className="surface-card surface-card-padded">
              <p style={{margin: '0 0 20px', color: 'var(--color-text-muted)'}}>
                Are you sure you want to cancel your subscription? This can't be undone.
              </p>
              <div style={{display: 'flex', gap: 12}}>
                <button className="btn-brand btn-brand-danger" onClick={() => this.cancelSubscription(subscription)}>
                  Cancel subscription
                </button>
                <button className="btn-brand btn-brand-outline" onClick={() => this.props.history.push('/')}>
                  Home
                </button>
              </div>
            </div>
          ) : (
            <div className="alert callout callout-neutral">Your subscription has been canceled.</div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(SubscriptionCancel);
